/* @flow */

import React from 'react';
import classNames from 'classnames';
import type { Node } from 'react';

// Styles
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './ContentWithSidebar.style';

// Hooks
import useSidebar from 'src/shared/app/base/component/template/hooks/useSidebar';

// Components
import Sidebar from './sidebar/SideBar';

type Props = {
  children: Node,
  small?: boolean,
  noSurvey?: boolean,
  hideNewTopicButton?: boolean,
  className?: string,
};

const useStyles = createUseThemeStyles(styles);

const ContentWithSidebar = ({
  children,
  small,
  noSurvey = false,
  hideNewTopicButton = false,
  className,
}: Props) => {
  const classes = useStyles();

  const { hasSidebar, showSurvey, showCreateTopicButton, eventSponsors } =
    useSidebar(noSurvey, hideNewTopicButton);

  return (
    <div
      className={classNames(classes.root, className, {
        [classes.small]: small,
      })}
    >
      {hasSidebar && (
        <Sidebar
          small={small}
          showSurvey={showSurvey}
          showCreateTopicButton={showCreateTopicButton}
          eventSponsors={eventSponsors}
        />
      )}
      {children}
    </div>
  );
};

export default React.memo<Props>(ContentWithSidebar);
